export { default as useLifestylesAuthorsFilter } from './useLifestylesAuthorsFilter';
